import { render, staticRenderFns } from "./EnvironmentDataTable.vue?vue&type=template&id=36f263e7"
import script from "./EnvironmentDataTable.vue?vue&type=script&lang=js"
export * from "./EnvironmentDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports